import React, { useRef, useContext, useState, useEffect } from "react";
import { Dialog, Toast } from "primereact";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { formatDate, getDateTimeSQL3, getMonthNames } from "../../../../../../Base/Services/FechasService";
import Loader from "../../../../../../Base/Components/Loader/Loader";

import { getUsuarios } from "../../../../../../Base/API/IT/Users/UserRequests";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import { ObtenerEncabezadoIngresos } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { getCalendarioMensual } from "../../../../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { EditarLiquidacion, getLiquidacionIngreso, getUltimaLiquidacionContable, GuardarLiquidacion } from "../../../../../../API/Suministros/Liquidaciones/LiquidacionesRequest";
import { ObtenerDetalleIngresos } from "../../../../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { getDateString, getDateTimeStringSQL } from "../../../../../../Base/Services/Moment/Luxon";
import { formatNumberDecimal } from "../../../../../../Base/Services/FormatTemplate";
import { getInformacionEmpresa } from "../../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { InputNumber } from "primereact/inputnumber";

pdfMake.vfs = pdfFonts.pdfMake.vfs;



const LiquidacionDeIngresos = ({ingreso}) => {
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const initialValues = {
    IdLiquidacion: -1,
    FechaFormato: new Date(),
    AlturaFirma: 50,
  };

  const { values, setValues, handleInputChange, handleChange, resetForm, error, setError } = useForm(initialValues);
  const [areasList, setAreasList] = useState([]);
  const [revisadoList, setRevisadoList] = useState([]);
  const [aprobadoList, setAprobadoList] = useState([]);
  const [ingresoEnc, setIngresoEnc] = useState([]);
  const [mesLiquidacion, setMesLiquidacion] = useState('')
  const [anioLiquidacion, setAnioLiquidacion] = useState(0);
  const [loading, setLoading] = useState(false);


  const getInfo = async () =>{
    setLoading(true)

    const infoEmpresa = await getInformacionEmpresa()
    const ingresosDetTempo = await ObtenerDetalleIngresos(ingreso?.NumeroIngreso)
    const ingreosTempo = await ObtenerEncabezadoIngresos(ingreso?.NumeroIngreso)

    setIngresoEnc(ingreosTempo)
    const areasTempo = await getAreasAct()
    setAreasList(areasTempo)
    const usersTempo = await getUsuarios()

    setRevisadoList(
      usersTempo
        .filter(user => user.IdRol === 36)
        .map(user => ({
          IdUserReviso: user.IdUser,
          UserNameReviso: user.UserName,
          UsuarioReviso: user.Usuario,
          ...user 
        }))
    );
    setAprobadoList(
      usersTempo
        .filter(user => user.IdUser === 30)
        .map(user => ({
          IdUserAprobo: user.IdUser,
          UserNameAprobo: user.UserName,
          UsuarioAprobo: user.Usuario,
          ...user 
        }))
    );


    let IdLiquidacionContable = ingreso?.IdLiquidacionContable ? ingreso?.IdLiquidacionContable : 0
    const numero = await crearFormatoNumero(ingreosTempo[0]?.FechaIngreso, IdLiquidacionContable)


    let tempoValues = { ...values, ...numero }

    let datosEnviar = {
      IdIngreso: ingreso?.IdIngreso,
      IdLiquidacion: IdLiquidacionContable
    }

    if(IdLiquidacionContable > 0){
      const tempoLiquidacion = await getLiquidacionIngreso(datosEnviar)
      if (tempoLiquidacion?.length > 0) {
        tempoValues = {
          ...tempoValues, ...tempoLiquidacion[0],
          FechaFormato: new Date(tempoLiquidacion[0]?.FechaFormato),
        }
      }
    }else if(ingreso?.IdIngreso){
      tempoValues.IdUserCreate = userAuth.IdUser
      tempoValues.UserNameCreate = userAuth.UserName
      tempoValues = { ...tempoValues, ...numero }
    }

    setValues(tempoValues)

    generar(ingreosTempo[0], ingresosDetTempo, tempoValues, infoEmpresa[0]?.LogoPrimario)
    // setTimeout(() => {
    // }, 1000);

    setLoading(false)
  }
  

  const generar = (data, detalles, tempoValues, LogoEmpresa) => {
    let totalDesaduanajeD = 0
    let totalEmbalajeD = 0
    let totalFlete = 0
    let totalOtrosGastos = 0
    let totalPrecioUnD = 0
    let totalIngreso = 0
    let totalCostoD = 0
    let totalMontoD = 0
    let totalMontoL =0
    let totalCostoL =0
    let totales = {}

    detalles?.map((e) => {
      totalIngreso = e.Ingreso + totalIngreso
      totalDesaduanajeD = e.DesaduanajeD + totalDesaduanajeD
      totalEmbalajeD = e.EmbalajeD + totalEmbalajeD
      totalFlete = e.FleteD + totalFlete
      totalOtrosGastos = e.OtrosCostosD + totalOtrosGastos
      totalPrecioUnD = e.PrecioUD + totalPrecioUnD
      totalCostoD = e.CostoD + totalCostoD
      totalCostoL = e.CostoL + totalCostoL
      totalMontoD = e.MontoD + totalMontoD
      totalMontoL = e.MontoL + totalMontoL
    })

    totales = {
      totalIngreso: totalIngreso,
      totalDesaduanajeD: totalDesaduanajeD,
      totalEmbalajeD: totalEmbalajeD,
      totalFlete: totalFlete,
      totalOtrosGastos: totalOtrosGastos,
      totalPrecioUnD: detalles.length < 2 ? detalles[0]?.PrecioD : 0,
      totalCostoD,
      totalMontoD,
      totalMontoL,
      totalCostoL
    }


    let margen = detalles.length >= 10 ?  [-20, 100, -10, -10] :  [-20, 30, -10, -10]

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [40, 65, 30, 60],

      content: [
        {
          margin: [0, 0, 5, 0],
          columns: [
            {
              table: {
                widths: [80, 210],
                margin: [0, 0, 15, 5],
                body: [
                  [
                    { text: "Proveedor", style: "encabezado" },
                    { text: `${data.CustomerName}`, style: "contenido" },
                  ],
                  [
                    { text: "Comentario", style: "encabezado" },
                    {
                      text: `${tempoValues.Comentario || ''}`,
                      style: "contenido",
                    },
                  ],
                  [
                    { text: "Factura", style: "encabezado" },
                    { text: `${data.Factura}`, style: "contenido" },
                  ],
                  [
                    { text: "Fecha", style: "encabezado" },
                    {
                      text: `${getDateString(values.FechaFormato)}`,
                      style: "contenido",
                    },
                  ],
                  [
                    { text: "Área", style: "encabezado" },
                    { text: `${values.Area?.Area ? values.Area?.Area : tempoValues?.Area || ''}`, style: "contenido" },
                  ],
                ],
              },
            },

            {
              margin: [20, 0, 15, 10],
              table: {
                widths: [70, 110],
                // heights: 40,
                body: [
                  [
                    { text: 'Costo Total $', style: 'encabezado', margin: [0, 0, 0, 0] },
                    { text: `$ ${formatNumberDecimal(totales.totalMontoD)}`, style: 'valoresContables', margin: [0, 0, 0, 0] }
                  ],
                  [
                    { text: 'Costo Total L:', style: 'encabezado', margin: [0, 0, 0, 0] },
                    { text: `L ${formatNumberDecimal(totales.totalMontoL)}`, style: 'valoresContables', margin: [0, 0, 0, 0] }
                  ],
                ]
              }
            },

            {
              image: LogoEmpresa,
              width: 200,
              margin: [-100, -20, -10, -0]
            },
          ],
        },

        {
          margin: [0, 15, 0, 0],
          columns: [
            { text: ' Serviciones Aduanales', style: 'encabezado', width: 80 },
            { text: `$ ${formatNumberDecimal(totales.totalDesaduanajeD)}`, style: `contenido`, width: 40 },
            { text: ` Flete`, style: `encabezado`, width: 30, margin: [10, 0, 0, 0] },
            { text: `$ ${formatNumberDecimal(totales.totalFlete)}`, style: `contenido`, width: 40 },
            { text: ` Embalaje`, style: `encabezado`, width: 50, margin: [10, 0, 0, 0] },
            { text: `$ ${formatNumberDecimal(totales.totalEmbalajeD)}`, style: `contenido`, width: 40 },
            { text: ` Otros Costos`, style: `encabezado`, width: 60, margin: [10, 0, 0, 0] },
            { text: `$ ${formatNumberDecimal(totales.totalOtrosGastos)}`, style: `contenido`, width: 40 },
          ]
        },

        {
          margin: [0, 5, 0, 5],
          table: {
            headerRows: 1,
            widths: [35, 170, 50, 50, 45, 50, 50, 55, 60, 50],
            body: [
              [
                { text: 'Cantidad', style: 'headerTable' },
                { text: 'Descripción', style: 'headerTable' },
                { text: 'Costo según Factura', style: 'headerTable' },
                { text: 'Servicios Aduanales', style: 'headerTable' },
                { text: 'Flete', style: 'headerTable' },
                { text: 'Embalaje', style: 'headerTable' },
                { text: 'Otros Costos', style: 'headerTable' },
                { text: 'Costo Total US$', style: 'headerTable' },
                { text: 'Costo Total HN L.', style: 'headerTable' },
                { text: 'Precio Unit', style: 'headerTable' },
              ],
              ...detalles.map(item => [
                { text: item.Ingreso, style: 'textoCentrado' },
                { text: item.NombreProducto, style: 'contenidoLeft' },
                colum('$', item.CostoD, 'valoresContables', 50),
                colum('$', item.DesaduanajeD, 'valoresContables', 50),
                colum('$', item.FleteD, 'valoresContables', 45),
                colum('$', item.EmbalajeD, 'valoresContables', 50),
                colum('$', item.OtrosCostosD, 'valoresContables', 50),
                colum('$', item.MontoD, 'valoresContables', 55),
                colum('L', item.MontoL, 'valoresContables', 60),
                colum('$', item.PrecioD, 'valoresContables', 50),
              ]),

              [
                { text: 'Total', style: 'contenidoJustify' },
                { text: '', style: 'contenidoJustify' },
                colum('$', totales.totalCostoD, 'valoresContables2', 50),
                colum('$', totales.totalDesaduanajeD, 'valoresContables2', 50),
                colum('$', totales.totalFlete, 'valoresContables2', 45),
                colum('$', totales.totalEmbalajeD, 'valoresContables2', 50),
                colum('$', totales.totalOtrosGastos, 'valoresContables2', 50),
                colum('$', totales.totalMontoD, 'valoresContables2', 55),
                colum('L', totales.totalMontoL, 'valoresContables2', 60),
                { text: '', style: 'valoresContables2' }
              ]
            ]
          },
        },

        {
          columns: [
            {
              margin: [50, values?.AlturaFirma || 50 ,0,0],

              table: {
                widths: [150, 50, 150, 50, 150],
                headerRows: 2,
                body: [
                  [
                    { text: '', margin: [-20, 20, -10, -10] },
                    { text: '', margin: [-20, 20, -10, -10] },
                    { text: '', margin: [-20, 20, -10, -10] },
                    { text: '', margin: [-20, 20, -10, -10] },
                    { text: '', margin: [-20, 20, -10, -10] },
                  ],

                  [
                    [
                      { text: '', margin: margen },
                      {
                        border: [false, true, false, false],
                        text: `_____________________________________ \n
                        Elaborado Por\n` + `${tempoValues.UserNameCreate || ''}`,
                        style: 'firmas', width: [200]
                      },
                    ],

                    { text: '', margin: margen },

                    [
                      { text: '', margin: margen },
                      {
                        border: [false, true, false, false],
                        text: `_____________________________________ \n
                        Revisado Por\n` + `${values.UserNameReviso?.UserName ? values.UserNameReviso?.UserName : tempoValues.UserNameReviso || ''}`,
                        style: 'firmas', width: [200]
                      }
                    ],

                    { text: '', margin: margen },

                    [
                      { text: '', margin: margen },
                      {
                        border: [false, true, false, false],
                        text: `_____________________________________ \n
                        Aprobado\n` + `${values.UserNameAprobo?.UserName ? values.UserNameAprobo?.UserName : tempoValues.UserNameAprobo || ''}`,
                        style: 'firmas', width: [200]
                      }
                    ],
                  ]

                ]
              },
              layout: {
                defaultBorder: false
              }

            }
          ]
        }
      ],

      header: () => {
        return {
          margin: [40, 40, 55, 0],
          columns: [
            {
              text: `Reconocimiento de activo ${tempoValues.mesLiquidacion} ${tempoValues.anioLiquidacion} `,
              alignment: "left",
              // margin: [30,0, 20, 2],
              bold: true,
              fontSize: 16,
            },
            {
              text: `${tempoValues.NumeroLiquidacion}`,
              alignment: "right",
              // margin: [10, 0, 50, 2],
              fontSize: 16,
              bold: true,
            },
          ],
        };
      },

      footer: function (currentPage, pageCount) {
        return {
          margin: [40, 5, 55, 0],
          columns: [
            {
              text: `Fecha Impreso  ${formatDate(new Date())}`,
              alignment: "left",
              // margin: [20, 10, 20, 20],
              bold: true,
              fontSize: 10,
            },
            {
              text: `${currentPage.toString() + "/" + pageCount}`,
              alignment: "right",
              // margin: [35, 10, 35, 10],
              fontSize: 10,
              bold: true,
            },
          ],
        };
      },

      styles: {
        header: {
          fontSize: 15,
          bold: true,
          font: "Times-Roman",
        },
        encabezado: {
          fontSize: 7.3,
          bold: true,
          alignment: "left",
          alignItems: "center",
          lineHeight: 1.5,
        },
        contenido: {
          fontSize: 7.3,
          alignment: "justify",
          lineHeight: 1.5,
        },
        contenidoJustify: {
          fontSize: 7.3,
          alignment: "justify",
          lineHeight: 1.5,
        },
        contenidoLeft: {
          fontSize: 7.3,
          alignment: "left",
          lineHeight: 1.5,
        },
        valoresContables: {
          fontSize: 7.3,
          alignment: "right",
          lineHeight: 1.5,
        },
        valoresContables2: {
          fontSize: 7.3,
          alignment: "right",
          bold: true,
          lineHeight: 1.5,
        },
        headerTable: {
          fontSize: 7.3,
          fillColor: "lightgray",
          bold: true,
          lineHeight: 1.5,
          // margin: [10, 10, 10, 10],
          alignment: "center",
        },
        textoCentrado: {
          alignment: "center",
          bold: true,
          fontSize: 7.5,
          lineHeight: 1.5,
        },
        firmas: {
          fontSize: 9,
          bold: true,
          // decoration: 'underline',
          alignment: "center",
          // lineHeight: 3
        },
        infoDet: {
          fontSize: 9,
          alignment: "center",
          bold: true,
          margin: [65, 0, 0, 0],
        },
      },
    };

    // pdfMake.createPdf(docDefinition).open();
    let doc = pdfMake.createPdf(docDefinition);
    let f = document.getElementById('foo');
    let callback = function (url) { f.setAttribute('src', url); }
    doc.getDataUrl(callback, doc);
  }

  const colum = (moneda, valor, estilo, tama) => {
    return {
      columns: [
        { text: moneda, style: estilo, width: 10 },
        { text: `${formatNumberDecimal(valor)}`, style: estilo, width: tama - 10 },
      ]
    }
  }

  const crearFormatoNumero = async (FechaIngreso, IdLiquidacion) => {
    const tempoUltimoId = await getUltimaLiquidacionContable()
    const tempoCalendario = await getCalendarioMensual()

    if (tempoCalendario?.length > 0) {
      let fecha = new Date(FechaIngreso)
      let mes, anio, NombreMes

      tempoCalendario.map((a) => {
        if (fecha >= new Date(a.InicioMes) && fecha <= new Date(a.FinMes)) {
          mes = (a.NoMes).toString()
          anio = (a.Anio).toString()
          NombreMes = a.MesEsLargo
        }
      })

      let numeroMes = Number(mes)
      
      NombreMes = getMonthNames(numeroMes - 1, 'es')
      
      let nombreMesL = NombreMes.toLowerCase()
      setMesLiquidacion(nombreMesL)
      setAnioLiquidacion(anio)

      let Num = tempoUltimoId[0]?.NumeroLiquidacion.slice(-5)
      let Id = (Number(Num) + 1).toString()
      let Numero
      let año = anio.slice(-2)
      let final = 0

      if (tempoUltimoId[0]?.IdLiquidacion && IdLiquidacion === 0) {

        if (Id.length < 5 && Id.length !== 0) {
          final = Id.padStart(5, 0)
        }
        let formato = 'RA' + (mes.length === 2 ? `${mes}` : '0' + `${mes}`) + `${año}` + 'FI'
        Numero = formato + '-' + final
        values.NumeroLiquidacion = Numero

        return { NumeroLiquidacion: Numero, mesLiquidacion: nombreMesL, anioLiquidacion: anio, FormatoNumero: formato }

      } else {
        let formato = 'RA' + (mes.length === 2 ? `${mes}` : '0' + `${mes}`) + `${año}` + 'FI'
        Numero = formato + '-00001'
        values.NumeroLiquidacion = Numero
        return { mesLiquidacion: nombreMesL, anioLiquidacion: anio }
      }

    }

  }

  const verificarInfo = () => {
    let error = {};
    if (!values.Comentario) {
      error.Comentario = true;
      error.error = true;
    }
    if (!values.IdArea && !values.Area.IdArea) {
      error.IdArea = true;
      error.error = true;
    }
    if (!values.IdUserReviso && !values.UserNameReviso.IdUserReviso) {
      error.IdUserReviso = true;
      error.error = true;
    }
    if (!values.IdUserAprobo && !values.UserNameAprobo.IdUserAprobo) {
      error.IdUserAprobo = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const guardarLiquidacion = async () => {
    const e = verificarInfo();
    if(!e.error){
      setLoading(true)

      const fecha = getDateTimeSQL3(new Date())

      let Datos = {
        IdLiquidacion: values.IdLiquidacion,
        NumeroLiquidacion: values.NumeroLiquidacion,
        IdIngreso: ingreso.IdIngreso,
        IdArea: values.Area?.IdArea || values?.IdArea,
        Comentario: values.Comentario,
        FechaFormato: getDateTimeStringSQL(values.FechaFormato),
        IdUserCreate: userAuth.IdUser,
        FechaCreate: fecha,
        IdUserAprobo: values?.UserNameAprobo?.IdUser || values?.IdUserAprobo,
        IdUserReviso: values?.UserNameReviso?.IdUser || values?.IdUserReviso,
        IdEstado: 5,
        Revisado: values?.UserNameReviso?.IdUser ? 1 : 0,
        Aprobado: values?.UserNameAprobo?.IdUser ? 1 : 0,
        AlturaFirma: values?.AlturaFirma,
      }
      


      if(values?.IdLiquidacion > 0){
        const respuesta = await EditarLiquidacion(Datos)
        if(respuesta[0]?.ESTADO === 1){
          toastShow(toast, "success", "Editada", respuesta[0]?.MENSAJE);
          getInfo()
        }else{
          toastShow(toast, "error", "Error", respuesta[0]?.MENSAJE);
        }
      }else{
        const respuesta = await GuardarLiquidacion(Datos)
        if(respuesta[0]?.ESTADO === 1){
          toastShow(toast, "success", "Guardada", respuesta[0]?.MENSAJE);
          getInfo()
        }else{
          toastShow(toast, "error", "Error", respuesta[0]?.MENSAJE);
        }
      }


      setLoading(false)

    }
  }


  useEffect(() => {
    getInfo();
  }, []);

  return (
    <div >
      <Toast ref={toast} />
      <h3> <strong>Reconocimiento de activo {mesLiquidacion} {anioLiquidacion} </strong>  </h3>
      <div className="d-flex">
        <div className="field col-6 me-2  mt-2">
          <span className="p-float-label">
            <InputText
              name="Comentario"
              value={values.Comentario}
              onChange={handleInputChange}
              style={{ width: "100%" }}
              className={error.Comentario ? "p-invalid" : ""}
            />
            <label htmlFor="Comentario">Comentario</label>
          </span>
        </div>

        <div className="field col-3 me-2 mt-2">
          <span className="p-float-label">
            <AutoCompleteDropdown
              name={"Area"}
              value={values.Area}
              items={areasList}
              field={"Area"}
              label={"Area"}
              handleInputChange={handleInputChange}
              className={error.IdArea ? "p-invalid" : ""}
            />
          </span>
        </div>

        {/* Fecha */}
        <div className="field col-3 me-2 mt-2">
          <span className="p-float-label">
            <Calendar
              id="FechaFormato"
              name="FechaFormato"
              value={values?.FechaFormato}
              onChange={handleInputChange}
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              showIcon
            />
            <label htmlFor="Date">Fecha</label>
        </span>
        </div>
      </div>

      <div className="d-flex">
        <div className="field col-3 me-2 mt-2">
          <span className="p-float-label">
            <AutoCompleteDropdown
              name={"UserNameReviso"}
              value={values.UserNameReviso}
              items={revisadoList}
              field={"UserNameReviso"}
              label={"Revisado Por"}
              handleInputChange={handleInputChange}
              className={error.IdUserReviso ? "p-invalid" : ""}
            />
          </span>
        </div>

        <div className="field col-3 me-2 mt-2">
          <span className="p-float-label">
            <AutoCompleteDropdown
              name={"UserNameAprobo"}
              value={values.UserNameAprobo}
              items={aprobadoList}
              field={"UserNameAprobo"}
              label={"Aprobado Por"}
              handleInputChange={handleInputChange}
              className={error.IdUserAprobo ? "p-invalid" : ""}
            />
          </span>       
        </div>

        <div className="field col-3 me-2 mt-2">
          <span className="p-float-label">
            <InputNumber
              name="AlturaFirma"
              value={values.AlturaFirma}
              onChange={handleInputChange}
            />
            <label htmlFor="AlturaFirma">Altura Firma</label>
          </span>
        </div>

        <div className="mt-2">
          <Button
            icon="pi pi-save"
            tooltip="Guardar"
            style={{ marginLeft: 1 }}
            onClick={(e) => {guardarLiquidacion()}}
          />
        </div>

        <div className="mt-2">
          <Button
            icon="pi pi-sync"
            type="button"
            onClick={() => getInfo()}
            tooltip="Cargar"
            tooltipOptions={{
              position: "top",
            }}
            style={{ marginLeft: 1 }}
          />
        </div>
      </div>


      <Loader loading={loading} querySelector='#Id123' />
      <div id="Id123" className="mt-4">
        <iframe src={''} style={{ width: '75vw', height: '60vh', border: '1px solid #ccc' }} id='foo' />
      </div>
      
    </div>
  );
};

export default LiquidacionDeIngresos;
